import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const MarginWrapperDiv = styled.div`
  align-items: center;
  margin: ${Spacing.S24} ${Spacing.S32};
`
